import type { Trade } from 'lib/sdks/search';
import sortByLabel from '@utils/sort-by-label';

/* istanbul ignore next */
const flattenSkills = (
  skills: Trade['skills'],
): { id: number; label: string; parent?: { id: number; label: string } }[] => {
  const parentSkills = [];
  const childSkills: {
    id: number;
    label: string;
    parent: { id: number; label: string };
  }[] = [];
  const len = skills.length;

  for (let i = 0; i < len; i += 1) {
    const skill = skills[i];

    const { subSkills = [], id, label } = skill;
    parentSkills.push({ id, label });

    const subSkillLen = subSkills.length;

    for (let j = 0; j < subSkillLen; j += 1) {
      const subSkill = subSkills[j];
      childSkills.push({
        ...subSkill,
        parent: { id, label },
      });
    }
  }

  return (
    parentSkills
      .sort(sortByLabel)
      // @ts-ignore
      .concat(childSkills.sort(sortByLabel))
  );
};

/* istanbul ignore next */
export default flattenSkills;
